import { useId } from 'react';
import type { IconBaseProps } from './types';

/**
 * Boat with a diagonal slash indicating "off" / disabled state.
 * Designed in Claude Design, Phosphor-style (256x256 viewBox).
 * Uses an SVG mask so the slash cleanly cuts through the icon,
 * working on any background color (dark or light mode).
 * Used for "Transponder Off" reports.
 */
export const SailboatOffIcon = ({
  size = '1em',
  color = 'currentColor',
  title,
  ...props
}: IconBaseProps) => {
  const maskId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth="16"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {title && <title>{title}</title>}
      <mask id={maskId}>
        <rect width="256" height="256" fill="white" />
        <line
          x1="40"
          y1="40"
          x2="216"
          y2="216"
          stroke="black"
          strokeWidth="26"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <line x1="128" y1="48" x2="128" y2="24" />
        <line x1="128" y1="168" x2="128" y2="88" />
        <path d="M224,152c0,56-96,80-96,80s-96-24-96-80V125.77a8,8,0,0,1,5.47-7.59L128,88l90.53,30.18a8,8,0,0,1,5.47,7.59Z" />
        <path d="M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56" />
      </g>
      <line x1="40" y1="40" x2="216" y2="216" />
    </svg>
  );
};
